<ibm-header-action title="action"
  routerLink="/">
  <svg ibmIconHome
    size="20"></svg>
</ibm-header-action>